import script from "./PartnershipSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnershipSection.vue?vue&type=script&setup=true&lang=js"

import "./PartnershipSection.vue?vue&type=style&index=0&id=eac449cc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eac449cc"]])

export default __exports__